export const bundleValues = {
  allTogether: 'all_together',
  separately: 'individual',
}

export const bundleOptions = [
  {
    label: 'En conjunto',
    value: bundleValues.allTogether,
  },
  {
    label: 'De forma individual',
    value: bundleValues.separately,
  },
]

export const bundleAllowedRequestsValues = {
  returnsAndExchanges: 'returns_and_exchanges',
  returnsOnly: 'returns_only',
  exchangesOnly: 'exchanges_only',
}

export const bundleAllowedRequestsOptions = [
  {
    label: 'Devoluciones y cambios',
    value: bundleAllowedRequestsValues.returnsAndExchanges,
  },
  {
    label: 'Solo devoluciones',
    value: bundleAllowedRequestsValues.returnsOnly,
  },
  {
    label: 'Solo cambios',
    value: bundleAllowedRequestsValues.exchangesOnly,
  },
]
